import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { MatSnackBar, MatDialog } from '@angular/material';
import { ModalConfirmComponent } from '../../../../components/modal-confirm/modal-confirm.component';
var AirportsListComponent = /** @class */ (function () {
    function AirportsListComponent(airportsService, snackBar, location, dialog) {
        this.airportsService = airportsService;
        this.snackBar = snackBar;
        this.location = location;
        this.dialog = dialog;
        this.headersTable = ['title', 'isActive', 'actions'];
        this.airport = [];
    }
    AirportsListComponent.prototype.ngOnInit = function () {
        this.listAirports();
    };
    AirportsListComponent.prototype.listAirports = function () {
        var _this = this;
        this.airportsService.list().then(function (response) {
            _this.airport = response.results;
        }, function (error) {
            console.log(error);
            _this.snackBar.open(error.error.message);
        });
    };
    AirportsListComponent.prototype.convertStatus = function (isActive) {
        if (isActive) {
            return 'Ativo';
        }
        return 'Inativo';
    };
    AirportsListComponent.prototype.remove = function (id) {
        var _this = this;
        this.dialog
            .open(ModalConfirmComponent, {
            width: '500px',
            data: {
                text: 'Deseja remover essa Aeroporto?',
                buttonConfirmText: 'Remover',
            },
        })
            .afterClosed()
            .toPromise()
            .then(function (result) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                if (result && result !== 'cancel') {
                    return [2 /*return*/, this.airportsService.deleteAirport(id).then(function (response) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                            return tslib_1.__generator(this, function (_a) {
                                this.listAirports();
                                this.snackBar.open('Aeroporto removida com sucesso.');
                                return [2 /*return*/];
                            });
                        }); }, function (error) {
                            console.log(error);
                            _this.snackBar.open(error.error.message);
                        })];
                }
                return [2 /*return*/];
            });
        }); })
            .catch(function (err) {
            _this.snackBar.open(err.message);
        });
    };
    return AirportsListComponent;
}());
export { AirportsListComponent };
